import { handleActions } from "redux-actions";
import { push } from "react-router-redux";
import { api } from "api";
import moment from "moment";
import Swal from "sweetalert2";
import { tipo_movimientos } from "utility/variables";
import { ToastStore } from "react-toasts";
import { actions as printActions } from "../print/print";

const endpoint = "historial_despachos_clientes";
const endpoint_fel = "factura_electronica";

// ------------------------------------
// Constants
// ------------------------------------

export const DATA = "R_VENTAS_DATA";
export const DATA_GRAFICA = "DATA_GRAFICA";
export const DETALLE = "R_VENTAS_DETALLE";
export const SORT = "R_VENTAS_SORT";
export const PAGE = "R_VENTAS_PAGE";
export const FECHA_INICIAL = "R_VENTAS_FECHA_INICIAL";
export const FECHA_FINAL = "R_VENTAS_FECHA_FINAL";
export const LOADER = "R_VENTAS_LOADER";
export const LOADER_GRAFICA = "R_VENTAS_LOADER_GRAFICA";
export const USUARIO = "R_VENTAS_USUARIO";
export const CLIENTE = "R_VENTAS_CLIENTE";
export const ESTADO = "R_VENTAS_ESTADO";
export const SET_IMPRESION = "R_VENTAS_SET_IMPRESION";
export const SET_RECIBO_CAJA_IMPRESION = "R_VENTAS_SET_RECIBO_CAJA_IMPRESION";
export const ESTADO_DESCARGA = "R_VEMTAS_ESTADO_DESCARGA";
export const ESTADO_DESCARGA_SIMPLE = "R_VEMTAS_ESTADO_DESCARGA_SIMPLE";
export const ESTADO_FACTURA = "R_VEMTAS_ESTADO_FACTURA";
export const FILTRO_FECHA = "R_VENTAS_FILTRO_FECHA";
export const BUSCADOR = "R_VENTAS_BUSCADOR";
export const SET_DESPACHO_IMPRESION = "SET_DESPACHO_IMPRESION";
export const SET_FORMATO_DESPACHO = "SET_FORMATO_DESPACHO";

// ------------------------------------
// Actions
// ------------------------------------

export const listar = (page = 1) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const store = getStore();
    const utiliza_fel = store.usuario.utiliza_fel;
    const fecha_inicial = store.reporte_ventas_costos.fecha_inicial;
    const fecha_final = store.reporte_ventas_costos.fecha_final;
    const search = store.reporte_ventas_costos.search;
    const params = { fecha_final, fecha_inicial, page, search };
    const usuario = store.reporte_ventas_costos.usuario;
    const cliente = store.reporte_ventas_costos.cliente;
    const filtro_fecha = store.reporte_ventas_costos.filtro_fecha;
    params.tipo = tipo_movimientos.VENTA;
    params.ordering = store.reporte_ventas_costos.ordering;
    params.activo = store.reporte_ventas_costos.estado;
    params.filtro_por = filtro_fecha;
    if (usuario) params.usuario_id = usuario.id;
    if (cliente) params.cliente_id = cliente.id;
    if (utiliza_fel) {
        params.estado_factura = store.reporte_ventas_costos.estado_factura;
    }
    api.get(`${endpoint}`, params)
        .catch((err) => {
            Swal("ERROR", "Ha ocurrido un error.", "error");
        })
        .then((resp) => {
            if (resp) {
                dispatch(setData(resp));
                dispatch(setPage(page));
            }
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${endpoint}/${id}`)
        .catch((err) => {
            dispatch(push("/reporte_ventas"));
        })
        .then((data) => {
            if (data) dispatch(setDetalle(data));
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const setUsuario = (value) => (dispatch) => {
    dispatch(_setUsuario(value));
    dispatch(listar());
};

export const setCliente = (value) => (dispatch) => {
    dispatch(_setCliente(value));
    dispatch(listar());
};

export const setFecha = (key, value) => (dispatch, getStore) => {
    const store = getStore();
    const reporte_ventas_costos = store.reporte_ventas_costos;
    if (key === "Inicial") {
        const fecha_inicial = new Date(value);
        const fecha_final = new Date(reporte_ventas_costos.fecha_final);
        if (fecha_final >= fecha_inicial) dispatch(setFechaInicial(value));
    } else {
        const fecha_inicial = new Date(reporte_ventas_costos.fecha_inicial);
        const fecha_final = new Date(value);
        if (fecha_final >= fecha_inicial) dispatch(setFechaFinal(value));
    }
    dispatch(listar());
};

export const sortChange = (sortName, sortOrder) => (dispatch, getStore) => {
    if (sortOrder === "asc") {
        dispatch(setSort(sortName));
    } else {
        dispatch(setSort(`-${sortName}`));
    }
    const store = getStore();
    const page = store.reporte_ventas_costos.page;
    dispatch(listar(page));
};

export const estadoChange = (estado) => (dispatch) => {
    dispatch(_setEstado(estado));
    dispatch(listar());
};

export const seleccionImpresion = (id, seccionImpresion) => (dispatch) => {
    dispatch(setLoader(true));
    dispatch(setVentaImpresion(null));
    let tipo = "comprobante";
    if (seccionImpresion == "reporteVentasReimpresionReciboCaja") {
        tipo = "recibo_caja";
    }
    api.get(`${endpoint}/reimpresion_venta`, { id, tipo })
        .catch((err) => {
            dispatch(push("/reporte_ventas"));
            dispatch(setVentaImpresion(null));
            dispatch(setReciboCajaImpresion(null));
        })
        .then((resp) => {
            if (resp) {
                let data_impresion = resp;
                let vuelto = 0;
                if (data_impresion.length === undefined) {
                    vuelto = data_impresion.vuelto_efectivo
                        ? data_impresion.vuelto_efectivo
                        : 0;
                    data_impresion.monto_efectivo =
                        data_impresion.monto_efectivo + vuelto;
                }
                if (seccionImpresion == "reporteVentasReimpresionReciboCaja") {
                    dispatch(setVentaImpresion(null));
                    dispatch(setReciboCajaImpresion(data_impresion));
                    dispatch(printActions.print(seccionImpresion));
                } else {
                    dispatch(setReciboCajaImpresion(null));
                    dispatch(setVentaImpresion(data_impresion));
                    dispatch(printActions.print(seccionImpresion));
                }
            }
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};



const seleccionImpresionDespacho = (data) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    dispatch(setDespachoImpresion(null));
    
    const store = getStore();
    const sucursal = store.usuario.sucursal;

    // Extraemos el ID del movimiento del objeto 'data'
    const movimientoId = data && data.movimiento ? data.movimiento.id : null;

    if (!movimientoId) {
        console.error("No se pudo encontrar el ID del movimiento en:", data);
        dispatch(setLoader(false));
        return;
    }

    api.get(`${endpoint}/reimpresion_despacho`, { id: movimientoId })
        .then((resp) => {
            if (resp && resp.despacho) {
                const despachoData = {
                ...resp.despacho,
                // NO volver a asignar sucursal
                detalle: (resp.despacho.detalle && resp.despacho.detalle.length > 0) 
                    ? resp.despacho.detalle 
                    : (data.detalles || []),
                nombre_cliente: resp.despacho.nombre_cliente || (data.cliente || "PÚBLICO GENERAL"),
                codigo_venta: resp.despacho.codigo_venta || data.movimiento.codigo || movimientoId
            };

                dispatch(setDespachoImpresion({
                    despacho_impresion: despachoData,
                    formato_despacho: resp.formato_despacho
                }));

                setTimeout(() => {
                    console.log("Disparando!");
                    // Asegúrate que este string sea igual al 'name' del PrintContainer
                    dispatch(printActions.print("ordenDespacho")); 
                }, 1200);
            }
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};



export const estadoFacturaChange = (estado) => (dispatch) => {
    dispatch(setEstadoFactura(estado));
    dispatch(listar());
};

export const filtroFechaChange = (filtro_fecha) => (dispatch) => {
    dispatch(_setFiltroFechaChange(filtro_fecha));
    dispatch(listar());
};

export const buscar = (search) => (dispatch) => {
    dispatch(setBuscador(search));
    dispatch(listar());
};


//-------------------------------------

// ------------------------------------
// PureActions
// ------------------------------------

export const setDataGrafica = (data_grafica) => ({
    type: DATA_GRAFICA,
    data_grafica,
});

export const setFechaInicial = (fecha_inicial) => ({
    type: FECHA_INICIAL,
    fecha_inicial,
});

export const setFechaFinal = (fecha_final) => ({
    type: FECHA_FINAL,
    fecha_final,
});

export const setData = (data) => ({
    type: DATA,
    data,
});

export const setDetalle = (detalle) => ({
    type: DETALLE,
    detalle,
});

export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});

export const setLoaderGrafica = (loader_grafica) => ({
    type: LOADER_GRAFICA,
    loader_grafica,
});

export const _setUsuario = (usuario) => ({
    type: USUARIO,
    usuario,
});

export const _setCliente = (cliente) => ({
    type: CLIENTE,
    cliente,
});

export const setSort = (ordering) => ({
    type: SORT,
    ordering,
});

export const setPage = (page) => ({
    type: PAGE,
    page,
});

export const _setEstado = (estado) => ({
    type: ESTADO,
    estado,
});

export const setVentaImpresion = (venta_impresion) => ({
    type: SET_IMPRESION,
    venta_impresion,
});

export const setReciboCajaImpresion = (recibo_caja_impresion) => ({
    type: SET_RECIBO_CAJA_IMPRESION,
    recibo_caja_impresion,
});

export const setDespachoImpresion = (despacho_impresion) => ({
    type: SET_DESPACHO_IMPRESION,
    despacho_impresion,
});

const setEstadoDescarga = (estado_descarga) => ({
    type: ESTADO_DESCARGA,
    estado_descarga,
});
const setEstadoDescargaSimple = (estado_descarga_simple) => ({
    type: ESTADO_DESCARGA_SIMPLE,
    estado_descarga_simple,
});
const setEstadoFactura = (estado_factura) => ({
    type: ESTADO_FACTURA,
    estado_factura,
});

export const _setFiltroFechaChange = (filtro_fecha) => ({
    type: FILTRO_FECHA,
    filtro_fecha,
});

export const setBuscador = (search) => ({
    type: BUSCADOR,
    search,
});

export const setFormatoDespacho = (formato_despacho) => ({
    type: SET_FORMATO_DESPACHO,
    formato_despacho,
});

export const actions = {
    leer,
    listar,
    setFecha,
    setUsuario,
    sortChange,
    setCliente,
    buscar,
    estadoChange,
    seleccionImpresion,
    estadoFacturaChange,
    filtroFechaChange,
    seleccionImpresionDespacho,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [DATA_GRAFICA]: (state, { data_grafica }) => {
        return {
            ...state,
            data_grafica,
        };
    },
    [DETALLE]: (state, { detalle }) => {
        return {
            ...state,
            detalle,
        };
    },
    [FECHA_INICIAL]: (state, { fecha_inicial }) => {
        return {
            ...state,
            fecha_inicial,
        };
    },
    [FECHA_FINAL]: (state, { fecha_final }) => {
        return {
            ...state,
            fecha_final,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LOADER_GRAFICA]: (state, { loader_grafica }) => {
        return {
            ...state,
            loader_grafica,
        };
    },
    [USUARIO]: (state, { usuario }) => {
        return {
            ...state,
            usuario,
        };
    },
    [CLIENTE]: (state, { cliente }) => {
        return {
            ...state,
            cliente,
        };
    },
    [SORT]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [ESTADO]: (state, { estado }) => {
        return {
            ...state,
            estado,
        };
    },
    [SET_IMPRESION]: (state, { venta_impresion }) => {
        return {
            ...state,
            venta_impresion,
        };
    },
    [SET_RECIBO_CAJA_IMPRESION]: (state, { recibo_caja_impresion }) => {
        return {
            ...state,
            recibo_caja_impresion,
        };
    },
    [ESTADO_DESCARGA]: (state, { estado_descarga }) => {
        return {
            ...state,
            estado_descarga,
        };
    },
    [ESTADO_DESCARGA_SIMPLE]: (state, { estado_descarga_simple }) => {
        return {
            ...state,
            estado_descarga_simple,
        };
    },
    [ESTADO_FACTURA]: (state, { estado_factura }) => {
        return {
            ...state,
            estado_factura,
        };
    },
    [FILTRO_FECHA]: (state, { filtro_fecha }) => {
        return {
            ...state,
            filtro_fecha,
        };
    },
    [BUSCADOR]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },

    [SET_DESPACHO_IMPRESION]: (state, { despacho_impresion, formato_despacho }) => ({
        ...state,
        despacho_impresion,
        formato_despacho
    }),

    [SET_FORMATO_DESPACHO]: (state, { formato_despacho }) => {
         return {
        ...state,
        formato_despacho,
        };
    },
};

// ------------------------------------
// InitialState
// ------------------------------------

export const initialState = {
    data: {},
    detalle: {},
    page: 1,
    data_grafica: {},
    usuario: null,
    cliente: null,
    fecha_inicial: moment().format("YYYY-MM-DD"),
    ordering: "",
    fecha_final: moment().format("YYYY-MM-DD"),
    loader: false,
    loaderGrafica: false,
    estado: true,
    venta_impresion: null,
    recibo_caja_impresion: null,
    estado_descarga: false,
    estado_descarga_simple: false,
    estado_factura: "",
    filtro_fecha: "fecha_venta",
    search: "",
    despacho_impresion: null,
    formato_despacho: null,
};

export default handleActions(reducers, initialState);